<template lang="html">
  <div class="scroll-spy">
    <div
      class="scroll-spy__container container"
      data-sticky-container
    >
      <div
        ref="sticky"
        :class="[ pageHeaderVisible ? 'scroll-spy__index--page-header-visible' : null ]"
        data-sticky
        data-sticky-class="top-sticky"
        class="scroll-spy__index"
      >
        <nav class="scroll-spy__nav">
          <ul
            v-scroll-spy-active
            v-scroll-spy-link
            class="scroll-spy__nav-list"
          >
            <li
              v-for="item in children"
              :key="item.id"
              class="scroll-spy__nav-item"
            >
              <a class="scroll-spy__nav-link">
                {{ item.columns.title }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div
        v-scroll-spy="{offset: 100}"
        class="scroll-spy__content"
      >
        <ScrollSpyItem v-for="child in children" :key="child.id" :resource="child" />
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Sticky from 'sticky-js'
import ScrollSpyItem from 'beisheim/components/blocks/scroll-spy-item'

export default {
  components: {
    ScrollSpyItem
  },
  mixins: [editable],
  data () {
    return {
      sticky: null
    }
  },
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    },
    pageHeaderVisible () {
      return this.$store.state.ui.pageHeaderVisible
    }
  },
  mounted () {
    this.sticky = new Sticky('.scroll-spy__index')
    setTimeout(() => this.sticky.update(), 500)
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/breakpoints';
@import '~beisheim/scss/colors';
@import '~beisheim/scss/scale';
@import '~beisheim/scss/grid';

.scroll-spy {
  margin: scale(10) 0;

  @include from(3) {
    margin: scale(20) 0;
  }
}

.scroll-spy__container {
  position: relative;
}

.scroll-spy__item {
  padding: scale(10) 0;
  border-top: 1px solid gray(4);
}

.scroll-spy__nav-link {
  cursor: pointer;

  &:hover {
    background-color: gray(4);
    padding-left: scale(2);
  }
}

.scroll-spy__nav-item {
  &:not(:last-child) {
    border-bottom: 1px solid gray(4);
  }

  &.active {
    .scroll-spy__nav-link {
      padding-left: scale(2);
    }
  }
}

.scroll-spy__nav-link {
  transition: all ease-in-out 0.3s;
  display: block;
  padding: scale(3) scale(3) scale(3) 0;
  position: relative;
}

.scroll-spy__index {
  display: none;

  @include from(4) {
    position: absolute;
    display: block;
    width: grid-columns(6) !important; // overwrites scroll-vue2-plugin style
    transition: transform ease-in-out 0.2s;

    &.top-sticky.scroll-spy__index--page-header-visible {
      transform: translateY(4rem);
    }
  }

  @include from(7) {
    width: max-grid-columns(4) !important; // overwrites scroll-vue2-plugin style
  }
}

.scroll-spy__nav {
  margin-right: scale(5);
}

.scroll-spy__content {
  @include from(4) {
    width: grid-columns(11);
    margin-left: auto;
  }

  @include from(7) {
    width: max-grid-columns(12);
  }
}

.scroll-spy__media {
  margin: scale(5) 0;
}
</style>
